import { get } from 'lodash';

export const b64toBlob = (b64Data, contentType, sliceSize) => {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);

  var blob = new Blob([byteArray], { type: contentType });
  return blob;
};

export const removeAccents = (str) => {
  let accents =
    'ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØŐòóôőõöøĎďDŽdžÈÉÊËěèéêëðÇçČčÐÌÍÎÏìíîïÙÚÛÜŰùűúûüĽĹľĺÑŇňñŘřŠšŤťŸÝÿýŽž';
  let accentsOut =
    'AAAAAAaaaaaasOOOOOOOOoooooooDdDZdzEEEEeeeeeeCcCcDIIIIiiiiUUUUUuuuuuLLllNNnnRrSsTtYYyyZz';
  str = str.split('');
  var strLen = str.length;
  var i, x;
  for (i = 0; i < strLen; i++) {
    if ((x = accents.indexOf(str[i])) !== -1) {
      str[i] = accentsOut[x];
    }
  }
  return str.join('');
};

export const actualPricePerPerson = (items, services) => {
  let price = 0;
  Object.keys(items || {}).map((key) => {
    items[key].map((item) => {
      price += get(item, 'item.value.price', 0);
      return null;
    });
    return null;
  });
  return price;
};

export const actualPrice = (persons) => {
  let price = 0;
  persons.map((person) => {
    Object.keys(get(person, 'items', {})).map((key) => {
      person.items[key].map((item) => {
        price += get(item, 'item.value.price', 0);
        return {};
      });
      return {};
    });
    return {};
  });
  return price;
};



// WEBPACK FOOTER //
// ./src/utils/index.js